/* eslint-disable */
// jshint ignore: start
/**
 * 회선 애니메이션 효과
 * @author KangBonghun(toto1323)
 * @param  {[type]} Q [description]
 * @return {[type]}   [description]
 */
(function(Q) {
  function FlowingSupport(graph) {
    this.flowMap = {};
    this.graph = graph;
  }

  FlowingSupport.prototype = {
    flowMap: null,
    length: 0,
    graph: null,
    timer: null,
    addFlowing: function(edgeOrLine, count) {
      var flowList = this.flowMap[edgeOrLine.id];
      if(!flowList) {
        flowList = this.flowMap[edgeOrLine.id] = [];
        this.length++;
      }
      while(--count >= 0) {
        var ui = new Q.ImageUI('dot.svg');
        ui.layoutByPath = true;
        ui.position = {
          x: 0,
          y: 0
        };
        ui.size = {
          width: 5 + (3 * edgeOrLine.getStyle(Q.Styles.EDGE_WIDTH))
        };

        ui.renderColor = edgeOrLine.getStyle(Q.Styles.EDGE_COLOR);
        flowList.push(ui);
        edgeOrLine.addUI(ui);
      }
    },
    removeFlowing: function(edgeOrLine) {
      var flowList = this.flowMap[edgeOrLine.id];
      if(!flowList) {
        return;
      }
      var edgeOrLine = this.graph.getElement(edgeOrLine.id);
      if(edgeOrLine) {
        flowList.forEach(function(ui) {
          edgeOrLine.removeUI(ui);
        })
      }
      this._doRemove(edgeOrLine.id);
    },
    _doRemove: function(id) {
      delete this.flowMap[id];
      this.length--;
    },
    stop: function() {
      cancelAnimationFrame(this.timer);
      this.timer = null;
    },
    start: function(fps, percent) {
      if(this.timer) {
        this.stop();
      }

      if(this.graph.editable == true) {
        return;
      }

      var byPercent = !!percent;
      var gap = byPercent ? 10 : 30;
      var perStep = 1;
      var fpsInterval = 1000 / (fps || 60);
      var startTime = Date.now();
      var offset = 0;
      var scope = this;
      scope.timer = requestAnimationFrame(function A() {
        var now = Date.now();
        var elapsed = now - startTime;

        if (elapsed > fpsInterval) {
          startTime = now - (elapsed % fpsInterval);

          offset += 1;
          for(var id in scope.flowMap) {
            var ui = scope.graph.getUI(id);
            if(!ui) {
              scope._doRemove(id);
              continue;
            }
            var lineLength = ui.length;
            if(!lineLength) {
              continue;
            }
            var flowList = scope.flowMap[id];
            if(byPercent) {
              var x = offset * perStep;
              flowList.forEach(function(ui) {
                ui.position = {
                  x: (x % 100) / 100,
                  y: 0
                };
                x += gap;
              });
            } else {
              var x = offset * perStep;
              flowList.forEach(function(ui) {
                var tmpX = x % lineLength;
                ui.position = {
                  x: tmpX < 1 ? 0 : tmpX, // x 값이 0.? 이면 이상한 위치로 튄다
                  y: 0
                };
                x += gap;
              });
            }
            scope.graph.invalidateUI(ui);

            //dashed line
            var data = ui.data;
            if(data instanceof Q.Edge) {
              if(data.getStyle(Q.Styles.EDGE_LINE_DASH)) {
                data.setStyle(Q.Styles.EDGE_LINE_DASH_OFFSET, -offset);
              }
            }
          }
        }
        scope.timer = requestAnimationFrame(A);
      });
    }
  }
  Q.FlowingSupport = FlowingSupport;
})(window.Q);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/flowingSupport.js